export const addMinutesToTime = (time: string, minutes: number): string => {
  if (!time || !/^\d{2}:\d{2}$/.test(time)) return '';

  const [hours, mins] = time.split(':').map(Number);
  const totalMinutes = hours * 60 + mins + minutes;
  const normalized = ((totalMinutes % 1440) + 1440) % 1440;

  const finalHours = Math.floor(normalized / 60);
  const finalMinutes = normalized % 60;

  return `${String(finalHours).padStart(2, '0')}:${String(finalMinutes).padStart(2, '0')}`;
};

export const getDefaultValidezForHorario = (tipo: 'entrada' | 'salida', hora: string) => {
  const inicio = addMinutesToTime(hora, -30);
  const fin = addMinutesToTime(hora, 30);

  if (tipo === 'entrada') {
    return {
      inicioValidezEntrada: inicio,
      finValidezEntrada: fin,
    };
  }

  return {
    inicioValidezSalida: inicio,
    finValidezSalida: fin,
  };
};
